export default __webpack_public_path__ + "static/media/a012-market-9.0daecb88.svg";